import { render } from "./EditMapModal.vue?vue&type=template&id=118510a8&scoped=true"
import script from "./EditMapModal.vue?vue&type=script&lang=js"
export * from "./EditMapModal.vue?vue&type=script&lang=js"

import "./EditMapModal.vue?vue&type=style&index=0&id=118510a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118510a8"]])

export default __exports__